
/**
 * https://github.com/PagerDuty-Samples/pagerduty-bulk-user-mgr-sample
 */
const base64Unicode =  (buffer) => {
    const uint6ToB64 = function(nUint6) {

        return nUint6 < 26 ?
            nUint6 + 65 :
            nUint6 < 52 ?
            nUint6 + 71 :
            nUint6 < 62 ?
            nUint6 - 4 :
            nUint6 === 62 ?
            43 :
            nUint6 === 63 ?
            47 :
            65;

    }
    const base64EncArr = function(aBytes) {

        let eqLen = (3 - (aBytes.length % 3)) % 3,
            sB64Enc = "";

        for (let nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
            nMod3 = nIdx % 3;
            /* Uncomment the following line in order to split the output in lines 76-character long: */
            /*
            if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
            */
            nUint24 |= aBytes[nIdx] << ((16 >>> nMod3) & 24);
            if (nMod3 === 2 || aBytes.length - nIdx === 1) {
                sB64Enc += String.fromCharCode(uint6ToB64((nUint24 >>> 18) & 63),
                    uint6ToB64((nUint24 >>> 12) & 63),
                    uint6ToB64((nUint24 >>> 6) & 63),
                    uint6ToB64(nUint24 & 63));
                nUint24 = 0;
            }
        }

        return eqLen === 0 ?
            sB64Enc :
            sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");
    };
    let encodedArr =  base64EncArr(new Uint8Array(buffer));
    // manually finishing up the url encoding fo the encodedArr
    encodedArr = encodedArr.replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=/g, '');
    return encodedArr;
}

const gen128x8bitNonce = () => {
    const array = new Uint8Array(42); //( generate 1024bits 8*128
    window.crypto.getRandomValues(array);
    return array;
};




const digestVerifier = (vString) => {
        const encoder = new TextEncoder();
        const verifier = encoder.encode(vString);
        return crypto.subtle.digest('SHA-256', verifier).then(hash=>{
            return hash;
        }).catch(err=>{
            console.log("err",err)
            return err;
        });
}

const codeVerifierAndChallenge =  () => {
    return new Promise((resolve, reject) => {
        // generate code verifier
        const generatedCode = gen128x8bitNonce();
        // base64 encode code_verifier
        const codeVerifier = base64Unicode(generatedCode.buffer);        

        // generate the challenge from the code verifier
        digestVerifier(codeVerifier).then(challengeBuffer=>{
            // base64 encode the challenge
            const challenge = base64Unicode(challengeBuffer); 
            return resolve({
                codeVerifier:codeVerifier,
                challenge:challenge
            })
        }).catch(err=>{
            console.log("err",err)
            reject(err)
        });
        
    })
}

module.exports = {
    codeVerifierAndChallenge,
    // base64Unicode,
    // gen128x8bitNonce,
    // digestVerifier
}